import { MENUS } from '@/common/constants';

const StepsMixin = {
  methods: {
    /**
     * Get the status for a given step
     * 
     * @param {Object} step - The step to get status for
     * @returns {string} - The status (SYNCED, IN_PROGRESS, FAILED, UNANSWERED)
     */
    getStepStatus(step) {
      const params = step.route.params || {};
      const questionId = step.route.name === MENUS.CLIENT.CUSTOM_QUESTIONS.id ? params.questionId : null;
      
      // Get the page using the appropriate parameters
      const page = this.getPage(step.route.name, params, questionId);
      return page ? page.status : 'UNANSWERED';
    },

    /**
     * Get the appropriate color for a step based on its status
     * 
     * @param {Object} step - The step to get color for
     * @returns {string} - The color name
     */
    getStatusColor(step) {
      if (!step.filled) return 'grey';
      if (step.status === 'SYNCED') return 'success';
      if (step.status === 'FAILED') return 'error';
      return 'warning';
    },

    /**
     * Get the appropriate icon for a step based on its status
     * 
     * @param {Object} step - The step to get icon for
     * @returns {string} - The icon name
     */
    getStatusIcon(step) {
      if (!step.filled) return 'fas fa-minus-circle';
      if (step.status === 'SYNCED') return 'fas fa-check-circle';
      if (step.status === 'FAILED') return 'fas fa-exclamation-circle';
      return 'fas fa-sync fa-spin';
    },

    /**
     * Get the status text for a step
     * 
     * @param {Object} step - The step to get text for
     * @returns {string} - The status text
     */
    getStatusText(step) {
      if (!step.filled) return 'Not Completed';
      if (step.status === 'SYNCED') return 'Synced';
      if (step.status === 'FAILED') return 'Sync Failed';
      return 'Syncing...';
    },

    /**
     * Maps incomplete steps to include status and filled properties
     * This transforms the basic incompleteSteps list into a format
     * suitable for display in the UI with status indicators
     * 
     * @returns {Array} - Array of steps with status and filled properties
     */
    mapIncompleteSteps() {
      if (!this.incompleteSteps) return [];
      
      return this.incompleteSteps.map(step => {
        // Extract the questionId if this is a custom question
        const questionId = step.route.name === MENUS.CLIENT.CUSTOM_QUESTIONS.id && 
                           step.route.params ? 
                           step.route.params.questionId : 
                           null;
                           
        return {
          ...step,
          status: this.getStepStatus(step),
          filled: this.isPageComplete(
            step.route.name, 
            step.route.params, 
            questionId
          )
        };
      });
    }
  }
};

export default StepsMixin; 